import { gql } from '@apollo/client'

export const DELETE_RATEPLAN = gql`
  mutation DeleteRatePlan($input: DeleteRatePlanInput!) {
    deleteRatePlan(input: $input) {
      message
    }
  }
`
